
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/citation-quality",
      function () {
        return require("private-next-pages/docs/citation-quality.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/citation-quality"])
      });
    }
  